"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    id: 'showroom',
    name: 'Showroom',
    background_color: '#4596b8',
    background_image: null,
    background_image_portrait: null,
    heading_font: 'https://fonts.raydiant.com/Kanit-Bold.woff',
    heading_text_color: '#ffffff',
    heading_2_font: null,
    heading_2_text_color: null,
    body_font: 'https://fonts.raydiant.com/Kanit-Regular.woff',
    body_text_color: '#ffffff',
    border_color: null,
};
//# sourceMappingURL=showroom.js.map


// WEBPACK FOOTER //
// ../raydiant-kit/lib/themes/showroom.js